import PropTypes from 'prop-types';

const RentDue = ({rentDue}) => {

  return (
    <div className='flex justify-between'>
      <p className='text-[22px] font-semibold'>Rent Due</p>
      <p className='text-[18px] font-semibold'>{`£${rentDue.toFixed(2)}`}</p>
    </div>
  )
}

export default RentDue;

RentDue.propTypes = {
    rentDue: PropTypes.number.isRequired,
};